import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import Select from "react-select";

import { RESET_FILTERS } from "@/modules/pg/shared/planningTable/reducers/filters/filters";
import { translate } from "@/modules/shared/IntlProviderWrapper";
import { LinesOrdersMaps } from "@/modules/pg/shared/planningTable/reducers/linesOrders/mappers";
import { ReduxFilters } from "@/modules/pg/shared/planningTable/reducers/logic/businessLogic";

import type { SetLockFilter } from "@/modules/pg/shared/planningTable/reducers/common";
import type {
    SetRescheduleOrderAction,
    SetRescheduleOrderBundleAction,
} from "@/modules/pg/shared/planningTable/reducers/common";
import type {
    SetHighlightedOrders,
    SetLastClickedOrderUuid,
} from "@/modules/pg/shared/planningTable/reducers/planningTable";
import type { SelectOptionItem } from "@/modules/shared/planningTable/typeFilterConsts";
import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";
import type { ResetFiltersAction } from "@/modules/pg/shared/planningTable/reducers/filters/filters";

type ActionTypes =
    | SetRescheduleOrderAction
    | ResetFiltersAction
    | SetHighlightedOrders
    | SetLastClickedOrderUuid
    | SetRescheduleOrderBundleAction
    | SetLockFilter;
type OwnProps = {};
type Props = OwnProps & ReduxProps;

class ReworkOrderFilter extends React.Component<Props> {
    onChange = (option: SelectOptionItem) => {
        if (!option) {
            this.props.reduxDispatch({ type: RESET_FILTERS, data: undefined });
        } else {
            ReduxFilters.setRescheduleOrderUuid(
                this.props.reduxDispatch,
                option.value,
                "line_order_list",
                this.props.is_filter_locked
            );
        }
    };

    getSelectedOptions = (): SelectOptionItem | null => {
        for (const line_order of this.props.orders) {
            for (const order of line_order.orders) {
                if (this.props.highlighted_orders_map && this.props.highlighted_orders_map.has(order.uuid)) {
                    return {
                        value: order.uuid,
                        label: order.external_id + " - " + order.process_num,
                    };
                }
            }
        }
        return null;
    };

    getOptions = (): SelectOptionItem[] => {
        const base_orders_uuids = [...LinesOrdersMaps.base_uuid_rework_orders.keys()];
        const rework_orders_uuids = [...LinesOrdersMaps.rework_uuid_base_order.keys()];
        const rework_related_uuids = base_orders_uuids.concat(rework_orders_uuids);
        const options: SelectOptionItem[] = [];
        for (const line_order of this.props.orders) {
            for (const order of line_order.orders) {
                if (!rework_related_uuids.includes(order.uuid)) {
                    continue;
                }
                options.push({
                    value: order.uuid,
                    label: order.external_id + " - " + order.process_num,
                });
            }
        }
        return options;
    };

    render() {
        return (
            <div className="order-filter">
                <Select
                    value={this.getSelectedOptions()}
                    placeholder={translate("common.operation", "Operation")}
                    options={this.getOptions()}
                    onChange={this.onChange}
                    isSearchable={true}
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 100 }),
                        menu: base => ({ ...base, width: "max-content", minWidth: "100%" }),
                    }}
                />
            </div>
        );
    }
}

const mapState = (state: ReduxState) => {
    const orders = state.gantt_chart_lines_orders.lines_orders.concat(
        state.gantt_chart_lines_orders.unscheduled_orders
    );
    const highlighted_orders_map = state.gantt_chart_planning_table.highlighted_orders.highlighted_orders_map;
    return {
        highlighted_orders_map,
        orders,
        is_filter_locked: state.gantt_chart_filters.is_filter_locked,
    };
};
const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(ReworkOrderFilter);
